const trendsES = {
    "view": {
        "form": {
            "label": {
                "filters": "Filtros",
                "period": "Período",
                "store": "Tienda",
                "label": "Etiqueta",
                "release": "Lanzamiento",
                "track": "Pista",
                "subuser": "Subusuario",
                "fetchingTrends": "Obteniendo tendencias de la base de datos"
            },
            "button": {
                "resetFilters": "Restablecer Filtros"
            },
            "options": {
                "store": {
                    "allStores": "Todas las Tiendas",
                    "downloadStores": "Tiendas de Descarga",
                    "streamingStores": "Tiendas de Streaming",
                    "streamStores": "Tiendas de Transmisión"
                },
                "label": {
                    "allLabels": "Todas las Etiquetas"
                },
                "release": {
                    "allReleases": "Todos los Lanzamientos"
                },
                "track": {
                    "allTracks": "Todas las Pistas"
                },
                "subuser": {
                    "selectSubuser": "Seleccionar Subusuario"
                },
                "period": {
                    "last7Days": "Últimos 7 Días",
                    "last14Days": "Últimos 14 Días",
                    "last30Days": "Últimos 30 Días",
                    "last45Days": "Últimos 45 Días",
                    "last60Days": "Últimos 60 Días",
                    "last75Days": "Últimos 75 Días",
                    "last90Days": "Últimos 90 Días"
                }
            }
        },
        "top10": {
            "title": "Top 10",
            "table": {
                "column": {
                    "artistName": "Artista",
                    "songMixName": "Nombre de Canción/Mezcla",
                    "numberOfSales": "Número de Ventas"
                }
            }
        },
        "storeWiseSales": {
            "title": "Ventas por Tienda",
            "label": {
                "amazonMusicStream": "Transmisión de Amazon Music",
                "appleMusicStream": "Transmisión de Apple Music",
                "beatportStream": "Transmisión de Beatport",
                "deezerStream": "Transmisión de Deezer",
                "facebookStream": "Transmisión de Facebook",
                "instagramStream": "Transmisión de Instagram",
                "itunesDownload": "Descarga de iTunes",
                "pandoraStream": "Transmisión de Pandora",
                "soundcloudStream": "Transmisión de SoundCloud",
                "spotifyStream": "Transmisión de Spotify",
                "tiktokStream": "Transmisión de Tiktok",
                "traxsourceStream": "Transmisión de Traxsource",
                "youtubeStream": "Transmisión de Youtube",
                "youtubePremiumStream": "Transmisión de Youtube Premium",
                "totalSales": "Ventas Totales",
                "storeMessage": "* Las etiquetas de las tiendas están ordenadas alfabéticamente (A-Z)"
            }
        },
        "salesByTerritory": {
            "title": "Ventas por Territorio"
        },
        "salesByGender": {
            "title": "Ventas por Género",
            "label": {
                "male": "Masculino",
                "female": "Femenino",
                "nonBinary": "No binario",
                "unknown": "Desconocido"
            }
        },
        "salesByAge": {
            "title": "Ventas por Edad",
            "label": {
                "male": "Masculino",
                "female": "Femenino",
                "genderOther": "No binario",
                "unknown": "Desconocido",
                "ageWiseSales": "Ventas por Edad",
                "ageUnknown": "Edad Desconocida"
            }
        },
        "message": {
            "noAccess": "No tienes acceso a este módulo, por favor contacta al equipo de soporte para más información.",
            "subscriptionExpired": "Tu suscripción ha expirado. Por favor <1>reanuda</1> tu suscripción para disfrutar de esta función.",
            "subscriptionUpgrade": "Tu plan de suscripción actual no soporta esta función. Por favor <1>actualiza</1> tu plan de suscripción para disfrutar de esta función."
        }
    }
};

export default trendsES;